import React from 'react';

import BasicDialog from '../scenes/Dialog/components/BasicDialog';
import UpgradeRecruiterAccount from '../scenes/Dialog/components/UpgradeRecruiterAccount';
import {get, post} from '../services/api';

export const FileHelper = {
  convertBase64ToBlob: (base64, name, type) => {
    const arr = base64.split(',');
    const bstr = atob(arr[1]);
    const buffer = new Uint8Array(bstr.length);
    for (let i = 0; i < bstr.length; ++i) {
      buffer[i] = bstr.charCodeAt(i);
    }

    return new File([buffer], name, { type });
  },

  getImageSize: file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = file => {
        const image = new Image();
        image.src = file.target.result;

        image.onload = function() {
          resolve({ width: this.width, height: this.height });
        };
      };

      reader.onerror = reject;

      reader.readAsDataURL(file);
    }),

  getImageFileByUrl: (url, name = null) =>
    new Promise((resolve, reject) => {
      if (
        process.env.NODE_ENV === 'production' &&
        new URL(url).origin !== window.location.origin
      ) {
        throw new Error('Unsafe value used in a resource URL context');
      }
      const fileName = name || url.split('/').pop();
      const ext = (fileName.split('.').pop() || 'png').toLowerCase();
      if (!['jpg', 'jpeg', 'png', 'gif'].includes(ext)) {
        reject();
      }

      const mimeType = `image/${
        ['jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp'].includes(ext) ? 'jpeg' : ext
      }`;

      get(
        url,
        {},
        {
          handleNotFound: () => reject(),
          handleSuccess: response => response.file
            ? resolve(new File([response.file], fileName, { type: mimeType }))
            : reject()
        },
        {responseType: 'blob'}
      );
    }),

  downloadInit: (file, filename) => {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(file);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },

  downloadInitByUrl: url => {
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },

  downloadByUrlWithChecking: (
    endpoint,
    params = {},
    {
      companyRight = 'You do not have permission to download files',
      exist = 'file not exist',
    },
    url
  ) => {
    post(
      endpoint,
      params,
      {},
      { headers: { 'X-Requested-With': 'XMLHttpRequest' } } // for old logic
    ).then(response => {
      if (response.right === 0) {
        if (response.companyRight === 1) UpgradeRecruiterAccount();
        else {
          BasicDialog({
            bodyRender: companyRight,
          });
        }
        return;
      }

      if (response.exist === 0) {
        BasicDialog({
          bodyRender: exist,
        });
      } else {
        if (response.restricted === 1) {
          BasicDialog({
            bodyRender: (
              <div style={{ whiteSpace: 'pre-line', maxWidth: '500px' }}>
                {response.message.replace(/<br\/>/gi, '\n')}
              </div>
            ),
          });
        } else {
          FileHelper.downloadInitByUrl(url || endpoint);
        }
      }
    });
  },
};

export default FileHelper;
